import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { EstateDistribution } from '/@/modules/estatedistribution/models/EstateDistribution';
import { User } from '/@/modules/user/models/User';

export class DistributionAlternate extends BaseEntityModel {
  id?: number;
  estateDistributionId?: number;
  userId?: number;
  estateDistribution?: Relationship<EstateDistribution>;
  user?: Relationship<User>;

  constructor(model: Partial<DistributionAlternate> = {}) {
    super(model);

    this.id = model.id;
    this.estateDistributionId = model.estateDistributionId;
    this.userId = model.userId;

    this.estateDistribution =
      EstateDistribution.mapModelOrNull(model.estateDistribution) || undefined;
    this.user = User.mapModelOrNull(model.user) || undefined;
  }

  getModelName(): string {
    return ModelType.DISTRIBUTION_ALTERNATE;
  }
}
